<template>
  <div class="floor-nav">
    <div class="container">
      <ul class="fl">
        <li
          class="fl"
          v-for="(item, index) in navList"
          :key="index"
          @mouseover="currentNavIndex=index"
          @mouseout="currentNavIndex=0"
        >
          <a :href="item.link" :class="{'is-active': index===currentNavIndex}" target="_blank">{{ item.name }}</a>
        </li>
      </ul>
      <div
        class="fr mobile-link"
        @mouseover="showMobileQrcode=true"
        @mouseout="showMobileQrcode=false"
      >
        <span>手机回收宝</span>
        <i class="mobile-qrcode"></i>
        <div class="code-wrap" v-show="showMobileQrcode">
          <img src="./img/qr.png" alt="">
          <!-- <img v-lazy="'//s1.huishoubao.com/static/pc/1001/img/code.png'"> -->
          <span class="span-app">回收宝APP</span>
          <span class="span-wx">关注微信</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      navList: [
        {
          name: '旧机回收',
          link: 'https://www.huishoubao.com/'
        },
        {
          name: '可乐优品',
          link: 'https://www.keleyoupin.com.cn/'
        }
        // {
        //   name: '手机租赁',
        //   link: 'https://www.nqyong.com/'
        // }
      ],
      currentNavIndex: 0,
      showMobileQrcode: false
    };
  }
};
</script>

<style scoped>
@import 'config.css';

.floor-nav {
  background-color: #fff;
  a {
    display: block;
    width: 232px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    color: $global-base-color;
  }
  .is-active {
    color: #fff;
    background-color: $global-primary-color;
  }
  .mobile-link {
    position: relative;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .mobile-qrcode {
    display: inline-block;
    width: 27px;
    height: 27px;
    margin-left: 10px;
    cursor: pointer;
    vertical-align: middle;
    background: url(//www.huishoubao.com/static/pc/1001/img/4_02.png) no-repeat center;
  }
  .code-wrap {
    z-index: 3;
    position: absolute;
    top: 100%;
    right: 0;
    padding: 10px;
    line-height: 24px;
    background-color: #fff;
    border: 1px solid $global-primary-color;
  }
  .span-app {
    margin-left: 10px;
  }
  .span-wx {
    float: right;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-nav.vue